// Strings in Enums:
// http://morrisdev.com/2016/09/typescript-enum-saves-time/

export enum ContentType {
  FORM_URL_ENCODED = <any>'application/x-www-form-urlencoded',
  JSON = <any>'application/json',
  TEXT = <any>'application/text'
}
